// Central config: swap image URLs, contact info, and copy without touching components.

export const SITE = {
  domain: "ibexacquisitions.com",
  leadEmail: "Brandon@Ibexacquisitions.com",
  secondaryEmail: "Katana@Ibexacquisitions.com",
  serviceArea:
    "We buy houses and land across the U.S., with deep, on-the-ground expertise in Denver and the greater Colorado market.",
  founderPhoto:
    "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/c7hdxgr1_B%26K%20Chatgpt1.png",
  // Header wordmark logo (transparent background — ibex head only)
  logoUrl:
    "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/7qf5q39d_Logo%20No%20background.png",
  // Footer wordmark logo (transparent background — horizontal lockup with tagline)
  logoFooterUrl:
    "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/29qa6va1_IBEX-logo-transparent.webp",
};

// Hero carousel images (16:9, warm golden hour). Swap freely.
export const HERO_IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1730609848752-41d8498b32eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxhZXJpYWwlMjBmYXJtbGFuZCUyMGdvbGRlbiUyMGhvdXJ8ZW58MHx8fHwxNzgzOTA2NzU3fDA&ixlib=rb-4.1.0&q=85",
    alt: "Aerial view of rolling green farmland at golden hour with warm amber light",
  },
  {
    src: "https://images.unsplash.com/photo-1747077268317-02dec556190e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxhZXJpYWwlMjBmYXJtbGFuZCUyMGdvbGRlbiUyMGhvdXJ8ZW58MHx8fHwxNzgzOTA2NzU3fDA&ixlib=rb-4.1.0&q=85",
    alt: "Wide open rural land parcel at sunrise with soft golden light",
  },
  {
    src: "https://images.unsplash.com/photo-1777058019384-fca55ee23102?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxhZXJpYWwlMjBmYXJtbGFuZCUyMGdvbGRlbiUyMGhvdXJ8ZW58MHx8fHwxNzgzOTA2NzU3fDA&ixlib=rb-4.1.0&q=85",
    alt: "Aerial farmland with winding road at golden hour",
  },
  {
    src: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&w=2000&q=85",
    alt: "Newly built modern home at dusk with warm interior lights glowing",
  },
  {
    src: "https://images.unsplash.com/photo-1515259387710-51e175f9ec6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxydXJhbCUyMGxhbmQlMjBhZXJpYWwlMjBkcm9uZXxlbnwwfHx8fDE3ODM5MDY3NTd8MA&ixlib=rb-4.1.0&q=85",
    alt: "Peaceful open pasture with oak tree in golden hour haze",
  },
];

export const ABOUT_BG =
  "https://images.unsplash.com/photo-1710014242857-97c541f1ec7d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxmb3Jlc3QlMjByaWRnZWxpbmUlMjBkdXNrfGVufDB8fHx8MTc4MzkwNjc1N3ww&ixlib=rb-4.1.0&q=85";

export const WHY_SELL_IMAGE =
  "https://images.unsplash.com/photo-1530844230930-8168b52d2d88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxydXJhbCUyMGxhbmQlMjBhZXJpYWwlMjBkcm9uZXxlbnwwfHx8fDE3ODM5MDY3NTd8MA&ixlib=rb-4.1.0&q=85";

export const NAV_LINKS = [
  { label: "How It Works", href: "#how-it-works" },
  { label: "What We Buy", href: "#what-we-buy" },
  { label: "Why Ibex", to: "/why" },
  { label: "About", href: "#about" },
  { label: "FAQ", href: "#faq" },
  { label: "For Builders", to: "/builders" },
  { label: "Contact", href: "#contact" },
];

// Builders page carousel imagery (16:9, new construction / infill / dusk).
export const BUILDER_HERO_IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=2000&q=80",
    alt: "Modern new-construction home exterior at dusk on an infill lot",
  },
  {
    src: "https://images.unsplash.com/photo-1613977257363-707ba9348227?auto=format&fit=crop&w=2000&q=80",
    alt: "Luxury modern desert home with pool, palm trees, and mountain backdrop",
  },
  {
    src: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=2000&q=80",
    alt: "Modern dark-clad infill new-build with warm entry lighting at dusk in the city",
  },
  {
    src: "https://images.unsplash.com/photo-1600607688969-a5bfcd646154?auto=format&fit=crop&w=2000&q=80",
    alt: "Modern dark-clad new-build home with wood siding at dusk on an infill lot",
  },
  {
    src: "https://images.unsplash.com/photo-1523217582562-09d0def993a6?auto=format&fit=crop&w=2000&q=80",
    alt: "Newly built modern home standing next to older houses on a transitional street",
  },
];

// Portfolio gallery — full-bleed sliding carousel on /builders (below What We Deliver).
export const GALLERY_IMAGES = [
  {
    src: "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/4wqxmvpy_nice%20house.png",
    alt: "Two-story new-construction home at dusk with warm interior lighting",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/lhvgt0b0_skinny%20house.png",
    alt: "Modern three-story infill home glowing at twilight between older bungalows",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/ykfpetz4_2houses.png",
    alt: "New home framed under construction beside a completed build on the same street at dusk",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/x4mn030m_tall%20house.png",
    alt: "Craftsman-inspired new build on a skinny infill lot at golden hour",
  },
];

// Before / after transformation pairs — draggable comparison slider on /builders.
export const BEFORE_AFTER_PAIRS = [
  {
    before:
      "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/qhqskx7q_Denver%20Before.png",
    after:
      "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/yrcdxm66_Denver%20After2.png",
    label: "Denver, CO",
  },
  {
    before:
      "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/b0szlowa_Denver%20Before%20small%20house.png",
    after:
      "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/rck6dyfa_Denver%20After%20small%20house.png",
    label: "Denver, CO",
  },
  {
    before:
      "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/w17me1d8_Scottsdale%20before.png",
    after:
      "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/ejav6ei7_Scottsdale%20After.png",
    label: "Scottsdale, AZ",
  },
  {
    before:
      "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/q2a892zq_Florida%20before.png",
    after:
      "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/5stpl8zt_Florida%20After.png",
    label: "Florida",
  },
  {
    before:
      "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/osof507h_Detroit%20before%20lot.png",
    after:
      "https://customer-assets.emergentagent.com/job_land-to-close/artifacts/qjl9tsi3_Detroit%20after%20lot.png",
    label: "Detroit, MI",
  },
];

export const FAQS = [
  {
    q: "How fast can you actually close?",
    a: "Once you accept our offer, closings can happen in as little as 14 days when title work is clean — and on average, expect about 30 days from accepted offer to money in hand. If you need more time, we close on your schedule; we’ve waited months when a seller needed it.",
  },
  {
    q: "Do I pay any fees, commissions, or closing costs?",
    a: "No. There are no agent commissions and no hidden fees, and we cover standard closing costs. The offer you accept is the amount you walk away with, less anything owed on the property such as back taxes or liens, which are settled at closing.",
  },
  {
    q: "How do you decide what my property is worth?",
    a: "We look at recent comparable land sales, road access, utilities, zoning, and what the property can realistically support. Then we make a fair offer and we’ll walk you through exactly how we got there. No lowball games — we’d rather earn a deal than trick one.",
  },
  {
    q: "My property has back taxes / a lien / title problems. Can you still buy it?",
    a: "Yes — this is our specialty. Liens and taxes are paid out of the sale proceeds at closing, and our title company resolves most paperwork issues at no cost to you.",
  },
  {
    q: "I inherited a property I’ve never even seen. Can you help?",
    a: "Absolutely, and you’re not alone — a large share of the sellers we work with inherited a house or land in another state. We handle everything remotely: mobile notaries, mailed documents, and closings you never have to travel for.",
  },
  {
    q: "Do I need to clean out the house before closing?",
    a: "No. Take what you want and leave the rest — furniture, boxes, all of it. We handle the cleanout.",
  },
  {
    q: "Do I need to clean up the property first?",
    a: "No. We buy 100% as-is. Old structures, junk, overgrowth, tenants on a handshake — leave it exactly as it sits.",
  },
  {
    q: "Am I obligated to anything by requesting an offer?",
    a: "Not at all. Our offer is free and no-obligation. If the timing isn’t right or the number doesn’t work, no hard feelings — plenty of sellers come back to us months later. And to be equally straightforward: our offers are subject to standard due diligence and title review, so an offer is the start of the process — not a guarantee of closing.",
  },
  {
    q: "What types of property do you buy?",
    a: "Houses in any condition — inherited, damaged, tenant-occupied, behind on payments — and land of every kind: vacant lots, acreage, infill parcels, and teardowns. If you’re not sure yours qualifies, send it over. The answer is usually yes.",
  },
];
